import { EventMeta } from '../../../interfaces/meta.interface';

type MailItemsAccessedFields = {
    risky_keyword: boolean;
};

const SetCASMailbox: EventMeta<MailItemsAccessedFields> = {
    title: 'CAS Mailbox Updated',
    default: {
        description: 'CAS Mailbox Updated',
        longDescription: 'An inbox rule has been deleted.',
        severity: 'info',
    },
    descriptionExtractor: (log: any) => ({
        risky_keyword: log.risky_keyword,
    }),
    classifications: [
        {
            severity: 'critical',
            description: (fields) => `A suspicious IP attempted to update CAS mailbox settings`,
            longDescription: (fields) =>
                `Client Access Server (CAS) mailbox settings were updated from a suspicious IP address that is not in your allowed list. This activity could indicate an attempt to manipulate mailbox access or configurations.`,
            predicates: {
                isAllowedASN: false,
                isAllowedCountry: false,
                isAllowedRegion: false,
                isAllowedIP: false,
                isFraudulentIP: true,
                isMicrosoftActivity: false,
            },
        },
        {
            severity: 'danger',
            description: (fields) => `An unapproved IP attempted to update CAS mailbox settings`,
            longDescription: (fields) =>
                `Client Access Server (CAS) mailbox settings were updated from an IP address that is not in your allowed list. This activity may indicate an attempt to modify mailbox access or configurations.`,
            predicates: {
                isAllowedASN: false,
                isAllowedCountry: false,
                isAllowedRegion: false,
                isAllowedIP: false,
                isMicrosoftActivity: false,
            },
        },
        {
            severity: 'warning',
            description: (fields) => `A suspicious IP updated CAS mailbox settings`,
            longDescription: (fields) =>
                `Client Access Server (CAS) mailbox settings were updated. The action originated from a suspicious IP. While mailbox setting changes are part of routine administration, performing this update from a suspicious IP is unusual and could signal an attempt to alter access methods or bypass controls. Review the change to confirm whether it was expected or potentially unauthorized.`,
            predicates: {
                isFraudulentIP: true,
                isMicrosoftActivity: false,
            },
        },
        {
            severity: 'info',
            description: (fields) =>
                `A Microsoft system operation (synchronization server IP) updated CAS mailbox settings`,
            longDescription: (fields) =>
                `Client Access Server (CAS) mailbox settings were updated. This was recorded as a Microsoft system operation event, with the IP tied to the Microsoft server responsible for handling synchronization. This entry is informational and reflects normal background activity. No action is required unless CAS mailbox updates appear inconsistent with your expected configuration.`,
            predicates: {
                isMicrosoftActivity: true,
            },
        },
        {
            severity: 'info',
            description: (fields) => 'CAS mailbox settings were updated',
            longDescription: (fields) =>
                `Client Access Server (CAS) mailbox settings were updated. No unusual conditions were flagged with this event.`,
        },
    ],
};

export default SetCASMailbox;
